import React, { Component } from "react";
import PropTypes from "prop-types";

export default class SiteSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isActive: false
    };

    this.makeActive = this.makeActive.bind(this);
    this.makeInactive = this.makeInactive.bind(this);
  }

  makeActive() {
    this.setState({
      isActive: true
    });
    $(".search-hide").addClass("hidden");
  }

  makeInactive() {
    this.setState({
      isActive: false
    });
    $(".search-hide").removeClass("hidden");
  }

  render() {
    return (
      <div>
        {this.state.isActive ? (
          <form
            className="d-flex search-wrapper align-items-center"
            method="get"
            action={this.props.remote}
          >
            <span className="material-icons text-primary">
              <i className="fa fa-search px-2" />
            </span>
            <input
              autoComplete="off"
              className="px-2 nav-search nav:focus text-primary-faded search-label flex-grow-1"
              name="query"
              type="text"
              placeholder="Search Solar Schools"
              value={this.state.term}
            />
            <span
              onClick={this.makeInactive}
              className="material-icons text-primary"
            >
              <i className="fa fa-close pl-4 pr-2" />
            </span>
          </form>
        ) : (
          <span
            onClick={this.makeActive}
            className="material-icons text-primary"
          >
            <i className="fa fa-search px-4" />
          </span>
        )}
      </div>
    );
  }
}

SiteSearch.propTypes = {
  remote: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/SiteSearch/index.js